import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Trivia from './views/Trivia.vue'
import TriviaCategory from './views/TriviaCategory.vue'
import TriviaQuestion from './views/TriviaQuestion.vue'
import SpotTheNot from './views/SpotTheNot.vue'
import SpotTheNotImage from './views/SpotTheNotImage.vue'
import Results from './views/Results.vue'
import TimesUp from './views/TimesUp.vue'
import Leaderboard from './views/Leaderboard.vue'
import Admin from './views/Admin.vue'

import VueAnalytics from 'vue-analytics'

Vue.use(Router)

Vue.use(VueAnalytics, {
  id: 'UA-135453231-3',
  Router
})

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/trivia',
      name: 'trivia',
      component: Trivia
    },
    {
      path: '/trivia/category',
      name: 'triviaCategory',
      component: TriviaCategory
    },
    { 
      path: '/trivia/questions',
      name: 'triviaQuestion',
      component: TriviaQuestion 
    },
    {
      path: '/spot-the-not',
      name: 'spot-the-not',
      component: SpotTheNot
    },
    {
      path: '/spot-the-not/images',
      name: 'spotTheNotImage',
      component: SpotTheNotImage
    },
    {
      path: '/results',
      name: 'results',
      component: Results
    },
    {
      path: '/times-up',
      name: 'timesUp',
      component: TimesUp
    },
    {
      path: '/leaderboard',
      name: 'leaderboard',
      component: Leaderboard
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin
    }
  ]
})
